import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons'
import { faQuestionCircle as faQuestionCircleSolid } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import IProps from './IProps'
import { TextInputLabel } from './style'
import style from './style.scss'

const TextInput = ({
  label,
  value,
  help,
  type,
  error,
  align,
  inputStyle,
  focus,
  defaultText,
  isRequired,
  isReadOnly,
  formType,
  color,
  background,
  inputColor,
  inputBackground,
  inputPadding,
  inputRef,
  defaultValue,
  ...props
}: IProps) => {
  const [helpOpen, setHelpOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  // TODO check text input value
  return (
    <div className={`${style.textInput} ${style[align]} ${style[inputStyle]}`}>
      {label ? (
        <TextInputLabel color={color} background={background} textAlign={align}>
          {label}
          {help ? (
            <div
              className={`${style.helpContainer} ${
                helpOpen ? style.open : undefined
              }`}
              onMouseEnter={() => setHelpOpen(true)}
              onMouseLeave={() => setHelpOpen(false)}
              onTouchStart={() => setHelpOpen(!helpOpen)}
              onClick={e => e.stopPropagation()}>
              <FontAwesomeIcon
                icon={helpOpen ? faQuestionCircleSolid : faQuestionCircle}
                className={style.helpIcon}
              />
              <div className={style.helpText}>{help}</div>
            </div>
          ) : undefined}
        </TextInputLabel>
      ) : undefined}

      {error ? <div className={style.errorContainer}>{t(error)}</div> : ''}

      {formType !== 'condition' ? (
        <input
          value={value}
          defaultValue={defaultValue}
          className={style.input}
          type={type}
          autoFocus={focus}
          placeholder={defaultText}
          readOnly={isReadOnly}
          required={isRequired}
          style={{
            color: inputColor,
            background: inputBackground,
            padding: inputPadding,
          }}
          {...props}
        />
      ) : (
        <textarea
          value={value}
          defaultValue={defaultValue}
          className={style.input}
          autoFocus={focus}
          placeholder={defaultText}
          readOnly={isReadOnly}
          required={isRequired}
          {...props}
        />
      )}
    </div>
  )
}
TextInput.defaultProps = {
  type: 'text',
  error: null,
  align: 'left',
  inputStyle: 'line',
  focus: false,
  defaultText: '',
}
export default TextInput
